<template>
    <b-modal id="alertOccurrenceDetailModal" :hide-footer="true" size="lg">
        <template slot="modal-header">
            <h5 class="modal-title">{{ $t('str.timeline.alertOccurrences.title') }}</h5>
            <button type="button" class="btn-close" @click="$bvModal.hide('alertOccurrenceDetailModal')"></button>
        </template>

        <dl class="row mb-0" v-if="selectedItem">
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.account') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.account) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.client') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.client) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.site') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.site) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.equipment') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.equipment) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.scheduledAt') }}</dt>
            <dd class="col-sm-8">{{ formatDate(selectedItem.scheduledAt) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.respondedAt') }}</dt>
            <dd class="col-sm-8">{{ formatDate(selectedItem.respondedAt) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.alertOccurrences.column.status') }}</dt>
            <dd class="col-sm-8">{{ selectedItem.status || '-' }}</dd>
        </dl>
    </b-modal>
</template>

<script>
import Common from '../../../common/Common.vue'

export default {
    props: {
        selectedItem: {
            type: Object,
            default: () => null,
        },
    },
    methods: {
        entityName(entity) {
            return entity?.name || entity || '-'
        },
        formatDate(value) {
            return value ? Common.formatDateAndTime(value) : '-'
        },
    },
}
</script>
